import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Chip
} from '@mui/material';
import {
  CheckCircle,
  RadioButtonUnchecked,
  Settings,
  AutoAwesome,
  Schedule,
  Notifications,
  AccountCircle
} from '@mui/icons-material';

const DEFAULT_STEPS = [
  { key: 'connectPlatform', label: 'Connect at least one platform', icon: <Settings /> },
  { key: 'generateContent', label: 'Generate your first AI post', icon: <AutoAwesome /> },
  { key: 'schedulePost', label: 'Schedule a post', icon: <Schedule /> },
  { key: 'enableNotifications', label: 'Enable notifications', icon: <Notifications /> },
  { key: 'completeProfile', label: 'Complete your profile', icon: <AccountCircle /> }
];

const OnboardingChecklist = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('onboardingProgress') || '{}');
    } catch {
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem('onboardingProgress', JSON.stringify(progress));
  }, [progress]);

  const completeStep = (key) => {
    setProgress((prev) => ({ ...prev, [key]: true }));
  };

  const actions = {
    connectPlatform: () => navigate('/settings'),
    generateContent: () => navigate('/content'),
    schedulePost: () => navigate('/content'),
    enableNotifications: () => navigate('/settings'),
    completeProfile: () => navigate('/settings')
  };

  const completedCount = DEFAULT_STEPS.filter((s) => progress[s.key]).length;
  const total = DEFAULT_STEPS.length;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">Getting Started Checklist</Typography>
          <Chip label={`${completedCount}/${total} complete`} color={completedCount === total ? 'success' : 'default'} size="small" />
        </Box>
        <List>
          {DEFAULT_STEPS.map((step) => {
            const done = !!progress[step.key];
            return (
              <ListItem key={step.key} secondaryAction={!done && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button size="small" variant="outlined" onClick={() => actions[step.key]()}>Go</Button>
                  <Button size="small" variant="contained" onClick={() => completeStep(step.key)}>Mark Done</Button>
                </Box>
              )}>
                <ListItemIcon>
                  {done ? <CheckCircle color="success" /> : <RadioButtonUnchecked color="disabled" />}
                </ListItemIcon>
                <ListItemText primary={step.label} secondary={step.key === 'connectPlatform' ? 'Enable posting & analytics' : undefined} />
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

export default OnboardingChecklist;


